<template>
  <div>
    <v-row no-gutters class="mb-2">
      <v-col cols="12" class="color-card-open pa-4 pr-7">
        <v-form @submit.prevent ref="form">
          <v-col cols="12" class="d-flex align-center pa-3">
            <v-icon size="32" class="mr-3" color="primary"
              >mdi-ticket-outline</v-icon
            >
            <h3>{{ titleCreateTickets }}</h3>
          </v-col>
          <v-row no-gutters class="mb-4 d-flex align-center">
            <v-col class="d-flex ml-2 mb-2" cols="12" md="">
              <BaseTextField
                :label="$t('new-event.ticket-management.tickets.fields.title')"
                hide-details
                :rules="[rules.totalRequired]"
                v-model="dataBulkEvent.name"
              />
            </v-col>
            <v-col v-if="hasSector" class="d-flex ml-2 mb-2" cols="12" md="">
              <v-autocomplete
                :label="$t('new-event.ticket-management.tickets.fields.sector')"
                item-value="value"
                item-text="text"
                persistent-placeholder
                hide-details
                :rules="[rules.totalRequired]"
                :items="eventSectorData"
                v-model="dataBulkEvent.sector"
                outlined
                dense
                class="rounded-lg"
              />
            </v-col>
            <v-col class="d-flex ml-2 mb-2" cols="12" md="">
              <BaseMoneyField
                :label="$t('new-event.ticket-management.tickets.fields.price')"
                hide-details
                :options="optionsCurrency"
                v-model="dataBulkEvent.price"
                selectContent
                :disabled="dataBulkEvent.disabled?.includes('price')"
                :rules="
                  dataBulkEvent.disabled?.includes('price')
                    ? []
                    : [rules.totalRequired || rules.nonNegativeNumber]
                "
              />
            </v-col>
            <v-col class="d-flex ml-2 mb-2" cols="12" md="">
              <BaseTextField
                type="number"
                :label="
                  $t('new-event.ticket-management.tickets.fields.quantity')
                "
                @wheel.prevent
                hide-spin-buttons
                hide-details
                v-model="dataBulkEvent.quantity"
                :rules="[rules.totalRequired, rules.nonNegativeNumber]"
                @focus="$event.target.select()"
              />
            </v-col>
            <v-col class="d-flex ml-2 mb-2" cols="12" md="">
              <BaseSelect
                label="Status"
                item-value="value"
                item-text="text"
                hide-details
                :items="status"
                :rules="[rules.totalRequired]"
                v-model="dataBulkEvent.status"
              />
            </v-col>
            <div class="d-flex ml-2">
              <v-btn
                icon
                class="primary white--text"
                width="32"
                height="32"
                @click="openItemModal"
              >
                <v-icon size="18">mdi-cog</v-icon>
              </v-btn>
            </div>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                class="rounded-pill primary mb-2"
                :loading="getLoadingBulkEvent"
                @click="handleCreateBulkTickets"
                >{{ $t("new-event.buttons.create-bulk-ticket") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <ModalTicketSettings
        :dialog.sync="dialogTicketSettings"
        @close="closeItemModal"
        :eventData="dataBulkEvent"
        @update:eventData="updateItemData($event)"
        :isBulkEvent="true"
      />
    </v-row>
    <v-row no-gutters class="mb-2">
      <v-col cols="12" class="color-card-open pa-4 pr-7">
        <v-col cols="12" class="d-flex align-center pa-3">
          <h3>{{ $t("new-event.recurring-event.list-tickets") }}</h3>
        </v-col>
        <v-row no-gutters class="mb-4 d-flex align-center">
          <v-col class="ml-2" cols="12">
            <v-data-table
              :headers="filteredHeaders"
              :items="ticketListSortedByDate"
              item-key="idproduto_variacao"
              class="custom-table custom-table-background"
              :no-data-text="$t('new-event.recurring-event.has-no-tickets')"
              :loading-text="$t('new-event.recurring-event.loading-tickets')"
              dense
              :items-per-page="10"
              multi-sort
              :footer-props="{
                itemsPerPageOptions: [10, 20, 50],
                itemsPerPageText: $t(
                  'new-event.recurring-event.events-per-page'
                ),
              }"
            >
              <template v-slot:item.ticketDate="{ item }">
                <span>{{ formatDateTime(item.ticketDate) }}</span>
              </template>

              <template v-slot:item.price="{ item }">
                <span>{{ formatCurrency(item.price) }}</span>
              </template>
              <template v-slot:item.name="{ item }">
                <span>{{
                  !item.name
                    ? $t("new-event.recurring-event.ticket-no-name")
                    : item.name
                }}</span>
              </template>
              <template v-slot:item.sector="{ item }">
                <span>{{
                  item.sector
                    ? getTranslatedText(
                        getEventSectorData?.sectors?.find(sector => {
                          return sector?.idsetor === item.sector;
                        })?.descricao
                      )
                    : $t("new-event.recurring-event.no-sector")
                }}</span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTextField from "../forms/BaseTextField.vue";
import BaseMoneyField from "../forms/BaseMoneyField.vue";
import BaseSelect from "../forms/BaseSelect.vue";
import ModalTicketSettings from "./EventSettingsModal/ModalTicketSettings.vue";
import mixins from "@/mixins";
import { getTranslatedText } from "@/utils";
import { mapActions, mapGetters } from "vuex";
import { getDefaultState } from "../../store/modules/newEvents";
const { formRules } = mixins;
export default {
  name: "BulkEventInsertion",
  components: {
    BaseTextField,
    BaseMoneyField,
    BaseSelect,
    ModalTicketSettings,
  },
  mixins: [formRules],
  data() {
    return {
      dataBulkEvent: null,
      dialogTicketSettings: false,
      form: null,
      optionsCurrency: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      tableHeaders: [
        {
          text: this.$t("new-event.ticket-management.tickets.title"),
          value: "name",
          align: "start",
          sortable: true,
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.sector"),
          value: "sector",
          align: "start",
          sortable: true,
        },
        {
          text: this.$t("new-event.recurring-event.data"),
          value: "ticketDate",
          align: "start",
          sortable: true,
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.price"),
          value: "price",
          align: "start",
          sortable: true,
        },
        {
          text: this.$t("new-event.ticket-management.tickets.fields.quantity"),
          value: "quantity",
          align: "start",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getSelectedDateToTickets",
      "getTicketList",
      "getEventSectorData",
      "getLoadingBulkEvent",
      "getAllDatesOfTickets",
      "getEventBasicData",
      "getEventSettingsData",
    ]),
    datePickerValue() {
      return this.getSelectedDateToTickets?.substring(0, 10);
    },
    batchItems() {
      const items = [
        {
          text: this.$t("new-event.ticket-management.tickets.no-batch"),
          value: 0,
        },
        { text: "1", value: 1 },
      ];
      if (!this.getTicketList || this.getTicketList.length === 0) {
        return items;
      }
      const maxBatch = Math.max(
        ...this.getTicketList.map(ticket => ticket.batch || 0)
      );
      for (let i = 2; i <= maxBatch + 1; i++) {
        items.push({ text: i.toString(), value: i });
      }
      return items;
    },
    eventSectorData() {
      return this.getEventSectorData?.sectors?.map(item => {
        return {
          value: item.idsetor,
          text: getTranslatedText(item.descricao),
        };
      });
    },
    filteredHeaders() {
      return this.tableHeaders.filter(header => {
        if (header.value === "sector") {
          return this.hasSector;
        }
        return true;
      });
    },
    hasSector() {
      return this.getEventSectorData?.hasSector;
    },
    ticketListSortedByDate() {
      if (
        this.getSelectedDateToTickets.length === 1 &&
        this.getSelectedDateToTickets[0] === "all"
      ) {
        return [...this.getTicketList].sort((a, b) => {
          return new Date(a.ticketDate) - new Date(b.ticketDate);
        });
      }
      const filteredTickets = this.getTicketList.filter(ticket =>
        this.getSelectedDateToTickets.includes(ticket.ticketDate)
      );
      return filteredTickets.sort((a, b) => {
        return new Date(a.ticketDate) - new Date(b.ticketDate);
      });
    },
    titleCreateTickets() {
      if (this.getSelectedDateToTickets.includes("all")) {
        return this.$t("new-event.recurring-event.create-ticket-all");
      }
      return this.$t("new-event.recurring-event.create-tickets-to-selection");
    },
    status() {
      return [
        {
          text: this.$t("new-event.settings.status.active"),
          value: "ATIVO",
        },
        {
          text: this.$t("new-event.settings.status.inactive"),
          value: "INATIVO",
        },
        {
          text: this.$t("new-event.settings.status.sold-out"),
          value: "ESGOTADO",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["createBulkTickets"]),
    getTranslatedText,
    openItemModal() {
      this.dialogTicketSettings = true;
    },
    closeItemModal() {
      this.dialogTicketSettings = false;
    },
    updateItemData(data) {
      this.dataBulkEvent = data;
      this.closeItemModal();
    },
    async handleCreateBulkTickets() {
      if (!this.$refs.form.validate()) {
        return;
      }
      let dates = this.getSelectedDateToTickets.includes("all")
        ? this.getAllDatesOfTickets
        : this.getSelectedDateToTickets;

      dates = [...new Set(dates)];

      await this.createBulkTickets({
        ticket: this.dataBulkEvent,
        dates: dates,
      });
      this.insertDefaultTicketsInformation();
    },
    formatDateTime(dateString) {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("pt-BR") +
        " - " +
        date.toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    async insertDefaultTicketsInformation() {
      const defaultState = getDefaultState();

      const data = {
        ...defaultState?.defaultTicketList,
        salesPeriodStart: this.getEventBasicData?.saleStart,
        salesPeriodEnd: this.getEventBasicData?.saleEnd,
        salesEndHoursAfter: this.getEventBasicData?.salesEndHoursAfter,
        accessPeriodStart: this.getEventSettingsData?.accessPeriodStart,
        accessPeriodEnd: this.getEventSettingsData?.accessPeriodEnd,
        commissionWeb: this.getEventSettingsData?.commissionWeb,
        typeTaxWeb: this.getEventSettingsData?.typeTaxWeb,
        taxWeb: this.getEventSettingsData?.taxWeb,
        minimumTax: this.getEventSettingsData?.minimumTax,
        commissionPos: this.getEventSettingsData?.commissionPos,
        typeTaxPos: this.getEventSettingsData?.typeTaxPos,
        taxPos: this.getEventSettingsData?.taxPos,
        hasProcessingTax: this.getEventSettingsData?.hasProcessingTax,
        processingTax: this.getEventSettingsData?.processingTax,
      };
      this.dataBulkEvent = data;
    },
  },
  beforeMount() {
    this.insertDefaultTicketsInformation();
  },
};
</script>

<style scoped>
.color-card-open {
  background-color: #f7f7fa;
  border-radius: 8px;
}

.custom-table {
  background-color: #f7f7fa;
}
</style>
